/**
 * Created by ashmitaggarwal on 13/09/18.
 */

import localStorageHelper from '../localStorageHelper';
import Auth from '../Auth';

export function verifyNumber(value) {
    var numberRex = new RegExp("^[a-zA-Z0-9]+$");
    if (numberRex.test(value)) {
        return true;
    }
    return false;
}

export function verifyPhoneNumber(value) {
    var numberRex = new RegExp("^[0-9]+$");
    if (numberRex.test(value) && value.length === 10
    ) {
        return true;
    }
    return false;
}

export function verifyClinicPhoneNumber(value) {
    var numberRex = new RegExp("^[0-9]+$");
    if (numberRex.test(value)
    ) {
        return true;
    }
    return false;
}

export function verifyAlphaNum(value) {
    var alphanumRex = new RegExp("^[a-zA-Z0-9\\-\\s]+$");
    if (alphanumRex.test(value)) {
        return true;
    }
    return false;
}


export function verifyEmail(value) {
    var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(value)) {
        return true;
    }
    return false;
}

export function verifyName(value) {
    var nameRex = /^(?![ .,&\-]+$)[a-zA-Z .,'&\-]+$/;
    if (nameRex.test(value)) {
        return true;
    }
    return false;
}


export function verifyUrl(value) {
    var urlRex = /[.]/;
    if (urlRex.test(value)) {
        return true;
    }
    return false;
}

export function verifyPincode(value) {
    var numberRex = new RegExp("^[0-9]+$");
    if (numberRex.test(value) && value.length === 6) {
        return true;
    }
    return false;
}


export function mappingUI(permission) {
    if (localStorageHelper.getItem("superAdmin"))
        return true;
    const userPermissions = Auth.isAuthenticated() && localStorageHelper.getItem("user_detail").roles[0].clinic_permission_id.role_access.indexOf(permission);
    return userPermissions !== -1
}

export function dashboardRouter(route) {
    if (localStorageHelper.getItem("superAdmin"))
        return route;
    return `/newdash` + route
}


export function getOriginalDateFormatConverter(date) {
    return new Date(date).getFullYear()  + "-" + (new Date(date).getMonth() + 1) + "-" +new Date(date).getDate()
}

export function getDateConverter(date) {
    return new Date(date).getDate() + "-" + (new Date(date).getMonth() + 1) + "-" + new Date(date).getFullYear()
}

export function getDateConverterReversal(date) {
    return date.split('-').reverse().join('-')
}

export function titleCase(str) {
    return (str.replace(/\s+/g, ' ').trim()).toLowerCase().split(' ').map(function (word) {
        return word.replace(word[0], word[0].toUpperCase());
    }).join(' ');
}

export function getReportTypes() {
    const reportType = ["Lab Report", "Ultrasound", "X-Ray", "ECG", "CT", "MRI", "Prescription", "Bill", "Others"];
    return reportType;
}

export function clinicmaster_id() {
    if (localStorageHelper.getItem("superAdmin") === false) {
        const clinicMasterId = localStorageHelper.getItem("selected_role").clinic_master_id._id
        return clinicMasterId
    }
    return ""
}

export function isClinicMasterOrClinic() {
    if (localStorageHelper.getItem("superAdmin") === false) {
        return localStorageHelper.getItem("selected_role").applicable_to_all_clinics
    }
    return ""
}


export function getClinicUserId() {
    if (localStorageHelper.getItem("superAdmin") === false) {
        if (localStorageHelper.getItem("selected_role").applicable_to_all_clinics === false) {
            const clinicId = localStorageHelper.getItem("selected_role").clinic_id._id;
            return clinicId
        }
    }
    return ""
}

export function isHealthSpaceUser() {
    return (localStorage.getItem('superAdmin') === 'true' || getClinicUserId() === "5c29feb4040ca45d93c5681e" || clinicmaster_id() === "5c29fd94040ca45d93c56804");
}

export function convertTime12to24(time12h) {
    const [time, modifier] = time12h.split(' ');
    let [hours, minutes] = time.split(':');
    if (hours === '12') {
        hours = '00';
    }
    if (modifier === 'PM') {
        hours = parseInt(hours, 10) + 12;
    }
    return hours + ':' + minutes;
}

export const timings = [
    {time: "12:00 AM", value: "00:00", count: 0},
    {time: "12:30 AM", value: "00:30", count: 1},
    {time: "01:00 AM", value: "01:00", count: 2},
    {time: "01:30 AM", value: "01:30", count: 3},
    {time: "02:00 AM", value: "02:00", count: 4},
    {time: "02:30 AM", value: "02:30", count: 5},
    {time: "03:00 AM", value: "03:00", count: 6},
    {time: "03:30 AM", value: "03:30", count: 7},
    {time: "04:00 AM", value: "04:00", count: 8},
    {time: "04:30 AM", value: "04:30", count: 9},
    {time: "05:00 AM", value: "05:00", count: 10},
    {time: "05:30 AM", value: "05:30", count: 11},
    {time: "06:00 AM", value: "06:00", count: 12},
    {time: "06:30 AM", value: "06:30", count: 13},
    {time: "07:00 AM", value: "07:00", count: 14},
    {time: "07:30 AM", value: "07:30", count: 15},
    {time: "08:00 AM", value: "08:00", count: 16},
    {time: "08:30 AM", value: "08:30", count: 17},
    {time: "09:00 AM", value: "09:00", count: 18},
    {time: "09:30 AM", value: "09:30", count: 19},
    {time: "10:00 AM", value: "10:00", count: 20},
    {time: "10:30 AM", value: "10:30", count: 21},
    {time: "11:00 AM", value: "11:00", count: 22},
    {time: "11:30 AM", value: "11:30", count: 23},
    {time: "12:00 PM", value: "12:00", count: 24},
    {time: "12:30 PM", value: "12:30", count: 25},
    {time: "01:00 PM", value: "13:00", count: 26},
    {time: "01:30 PM", value: "13:30", count: 27},
    {time: "02:00 PM", value: "14:00", count: 28},
    {time: "02:30 PM", value: "14:30", count: 29},
    {time: "03:00 PM", value: "15:00", count: 30},
    {time: "03:30 PM", value: "15:30", count: 31},
    {time: "04:00 PM", value: "16:00", count: 32},
    {time: "04:30 PM", value: "16:30", count: 33},
    {time: "05:00 PM", value: "17:00", count: 34},
    {time: "05:30 PM", value: "17:30", count: 35},
    {time: "06:00 PM", value: "18:00", count: 36},
    {time: "06:30 PM", value: "18:30", count: 37},
    {time: "07:00 PM", value: "19:00", count: 38},
    {time: "07:30 PM", value: "19:30", count: 39},
    {time: "08:00 PM", value: "20:00", count: 40},
    {time: "08:30 PM", value: "20:30", count: 41},
    {time: "09:00 PM", value: "21:00", count: 42},
    {time: "09:30 PM", value: "21:30", count: 43},
    {time: "10:00 PM", value: "22:00", count: 44},
    {time: "10:30 PM", value: "22:30", count: 45},
    {time: "11:00 PM", value: "23:00", count: 46},
    {time: "11:30 PM", value: "23:30", count: 47},
];

export const timing = [
    {time: "12:00 AM", value: "00:00", count: 0},
    {time: "12:15 AM", value: "00:15", count: 1},
    {time: "12:30 AM", value: "00:30", count: 2},
    {time: "12:45 AM", value: "00:45", count: 3},
    {time: "01:00 AM", value: "01:00", count: 4},
    {time: "01:15 AM", value: "01:15", count: 5},
    {time: "01:30 AM", value: "01:30", count: 6},
    {time: "01:45 AM", value: "01:45", count: 7},
    {time: "02:00 AM", value: "02:00", count: 8},
    {time: "02:15 AM", value: "02:15", count: 9},
    {time: "02:30 AM", value: "02:30", count: 10},
    {time: "02:45 AM", value: "02:45", count: 11},
    {time: "03:00 AM", value: "03:00", count: 12},
    {time: "03:15 AM", value: "03:15", count: 13},
    {time: "03:30 AM", value: "03:30", count: 14},
    {time: "03:45 AM", value: "03:45", count: 15},
    {time: "04:00 AM", value: "04:00", count: 16},
    {time: "04:15 AM", value: "04:15", count: 17},
    {time: "04:30 AM", value: "04:30", count: 18},
    {time: "04:45 AM", value: "04:45", count: 19},
    {time: "05:00 AM", value: "05:00", count: 20},
    {time: "05:15 AM", value: "05:15", count: 21},
    {time: "05:30 AM", value: "05:30", count: 22},
    {time: "05:45 AM", value: "05:45", count: 23},
    {time: "06:00 AM", value: "06:00", count: 24},
    {time: "06:15 AM", value: "06:15", count: 25},
    {time: "06:30 AM", value: "06:30", count: 26},
    {time: "06:45 AM", value: "06:45", count: 27},
    {time: "07:00 AM", value: "07:00", count: 28},
    {time: "07:15 AM", value: "07:15", count: 29},
    {time: "07:30 AM", value: "07:30", count: 30},
    {time: "07:45 AM", value: "07:45", count: 31},
    {time: "08:00 AM", value: "08:00", count: 32},
    {time: "08:15 AM", value: "08:15", count: 33},
    {time: "08:30 AM", value: "08:30", count: 34},
    {time: "08:45 AM", value: "08:45", count: 35},
    {time: "09:00 AM", value: "09:00", count: 36},
    {time: "09:15 AM", value: "09:15", count: 37},
    {time: "09:30 AM", value: "09:30", count: 38},
    {time: "09:45 AM", value: "09:45", count: 39},
    {time: "10:00 AM", value: "10:00", count: 40},
    {time: "10:15 AM", value: "10:15", count: 41},
    {time: "10:30 AM", value: "10:30", count: 42},
    {time: "10:45 AM", value: "10:45", count: 43},
    {time: "11:00 AM", value: "11:00", count: 44},
    {time: "11:15 AM", value: "11:15", count: 45},
    {time: "11:30 AM", value: "11:30", count: 46},
    {time: "11:45 AM", value: "11:45", count: 47},
    {time: "12:00 PM", value: "12:00", count: 48},
    {time: "12:15 PM", value: "12:15", count: 49},
    {time: "12:30 PM", value: "12:30", count: 50},
    {time: "12:45 PM", value: "12:45", count: 51},
    {time: "01:00 PM", value: "13:00", count: 52},
    {time: "01:15 PM", value: "13:15", count: 53},
    {time: "01:30 PM", value: "13:30", count: 54},
    {time: "01:45 PM", value: "13:45", count: 55},
    {time: "02:15 PM", value: "14:00", count: 56},
    {time: "02:00 PM", value: "14:15", count: 57},
    {time: "02:30 PM", value: "14:30", count: 58},
    {time: "02:45 PM", value: "14:45", count: 59},
    {time: "03:00 PM", value: "15:00", count: 60},
    {time: "03:15 PM", value: "15:15", count: 61},
    {time: "03:30 PM", value: "15:30", count: 62},
    {time: "03:45 PM", value: "15:45", count: 63},
    {time: "04:00 PM", value: "16:00", count: 64},
    {time: "04:15 PM", value: "16:15", count: 65},
    {time: "04:30 PM", value: "16:30", count: 66},
    {time: "04:45 PM", value: "16:45", count: 67},
    {time: "05:00 PM", value: "17:00", count: 68},
    {time: "05:15 PM", value: "17:15", count: 69},
    {time: "05:30 PM", value: "17:30", count: 70},
    {time: "05:45 PM", value: "17:45", count: 71},
    {time: "06:00 PM", value: "18:00", count: 72},
    {time: "06:15 PM", value: "18:15", count: 73},
    {time: "06:30 PM", value: "18:30", count: 74},
    {time: "06:45 PM", value: "18:45", count: 75},
    {time: "07:00 PM", value: "19:00", count: 76},
    {time: "07:15 PM", value: "19:15", count: 77},
    {time: "07:30 PM", value: "19:30", count: 78},
    {time: "07:45 PM", value: "19:45", count: 79},
    {time: "08:00 PM", value: "20:00", count: 80},
    {time: "08:15 PM", value: "20:15", count: 81},
    {time: "08:30 PM", value: "20:30", count: 82},
    {time: "08:45 PM", value: "20:45", count: 83},
    {time: "09:00 PM", value: "21:00", count: 84},
    {time: "09:15 PM", value: "21:15", count: 85},
    {time: "09:30 PM", value: "21:30", count: 86},
    {time: "09:45 PM", value: "21:45", count: 87},
    {time: "10:00 PM", value: "22:00", count: 88},
    {time: "10:15 PM", value: "22:15", count: 89},
    {time: "10:30 PM", value: "22:30", count: 90},
    {time: "10:45 PM", value: "22:45", count: 91},
    {time: "11:00 PM", value: "23:00", count: 92},
    {time: "11:15 PM", value: "23:15", count: 93},
    {time: "11:30 PM", value: "23:30", count: 94},
    {time: "11:45 PM", value: "23:45", count: 95}
];

export function getDay() {
    var a = new Date();
    var weekdays = new Array(7);
    weekdays[0] = "sun";
    weekdays[1] = "mon";
    weekdays[2] = "tues";
    weekdays[3] = "wednes";
    weekdays[4] = "thurs";
    weekdays[5] = "fri";
    weekdays[6] = "satur";
    var r = weekdays[a.getDay()];
    return r
}

export function parseQueryParams(query) {
    //You get a '?key=asdfghjkl1234567890&val=123&val2&val3=other'
    const queryArray = query.split('?')[1].split('&');
    let queryParams = {};
    for (let i = 0; i < queryArray.length; i++) {
        const [key, val] = queryArray[i].split('=');
        queryParams[key] = val ? val : true;
    }
    /* queryParams =
     {
     key:"asdfghjkl1234567890",
     val:"123",
     val2:true,
     val3:"other"
     }
     */
    return queryParams;
}

export function signOut() {
    localStorageHelper.clear();
    localStorage.removeItem("last_url");
    localStorageHelper.setItem("auth", false);
    window.location.pathname="/login"
    // this.props.history.push("/login");
}

export function changeReportType(reports, value) {
    for (var i in reports) {
        reports[i].type = value;
    }
    return reports
}

export function currentDate() {
    var d = new Date(),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
}


// WEBPACK FOOTER //
// ./src/util/globalHelper.js